
// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Views
import Billing from "views/Order/application/billing";
import Contact from "views/Order/application/contact";
import NotFound from "views/NotFound/application";


class RouteApp extends Component {

    handleComponent(type) {
        const actualPlan = this.props.data.plan.plan.name;
        if ( type === actualPlan ) {
            this.props.history.push("/");
        } else {
            if ( actualPlan === "free_trial" ) {
                switch (type) {
                    case "plan_m": case "professional":
                        return <Billing plan={type} />;
                    case "consulting_enterprise": case "consulting_professional": case "consulting_sunco":
                        return <Contact plan={type} />;
                    default:
                        return <NotFound />;
                }
            } else {
                switch (type) {
                    case "plan_m": case "consulting_enterprise": case "consulting_professional": case "consulting_sunco":
                        return <Contact plan={type} />;
                    case "professional":
                        return <Billing plan={type} />;
                    default:
                        return <NotFound />;
                }
            }
        }
    }

    render() {
        const { match } = this.props;
        return (
            <div className={"man-content"}>
                {this.handleComponent(match.params.type)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(RouteApp);

export default withRouter(connect_);